import React from "react";
import { ThreeDots } from "react-loader-spinner";
function Loader({ width = "75", height = "45" }) {
  return (
    <ThreeDots
      width={width}
      height={height}
      color="red"
      wrapperStyle={{
        display: "flex",
        justifyContent: "center",
      }}
      
    />
  );
}

export default Loader;
